import { Project } from '@/core/entity';
import { Fragment, UpdaterFunc } from '@/core/interface/common';

import {
  IFileGateway,
  IJobGateway,
  IProjectGateway,
  PresenterFunc,
  ProjectInput,
} from '../interface';

export class ProjectService {
  constructor(
    private readonly fileGateway: IFileGateway,
    private readonly jobGateway: IJobGateway,
    private readonly projectGateway: IProjectGateway,
  ) { }

  public async createProject(
    input: ProjectInput,
    file: File,
    presenter: PresenterFunc<Project | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc
  ) {
    presenter(null, null, true);

    try {
      const uploadItem = await this.jobGateway.getJobCsvUploadUrl();

      await this.fileGateway.upload(file, uploadItem.uploadUrl, 'text/csv');
      input.csvFile = uploadItem.fileUri;

      const result = await this.projectGateway.createProject(input, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }

  public async removeProject(
    id: string,
    presenter: PresenterFunc<Project | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
    refetchQueries?: string[],
  ) {
    presenter(null, null, true);

    try {
      const result = await this.projectGateway.removeProject(id, fragment, updater, refetchQueries);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }

  public async updateProject(
    id: string,
    input: ProjectInput,
    presenter: PresenterFunc<Project | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc
  ) {
    presenter(null, null, true);

    try {
      const result = await this.projectGateway.updateProject(id, input, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
